import React, { useState, useEffect, useRef } from "react";
import { Link, BrowserRouter as Router, Route } from "react-router-dom";
import "./style.scss";
import {
  getRouting,
  digitToRupeeNotation,
} from "../../../../../utils/common";
import { Helmet } from "react-helmet";
// import { PieChart } from "react-minimal-pie-chart";
import formulajs from "@formulajs/formulajs";
import { NumericFormat } from "react-number-format";

const RetirementCalculator = (props) => {
  const {} = props;

  const [currentAge, setcurrentAge] = useState(25);
  const [inflationRate, setinflationRate] = useState(6);
  const [retirementage, setretirementage] = useState(60);
  const [monthlyExpense, setmonthlyExpense] = useState(10000);
  const [expectedReturn, setexpectedReturn] = useState(8);
  const [totalSIP, settotalSIP] = useState(0);
  const [monthlyExpenseAge60, setmonthlyExpenseAge60] = useState(0);

  const [ageErr, setageErr] = useState(false);
  const [inflationErr, setinflationErr] = useState(false);
  const [retAgeErr, setretAgeErr] = useState(false);
  const [expenseErr, setexpenseErr] = useState(false);
  const [expectedErr, setexpectedErr] = useState(false);
  const [toggleButton, settoggleButton] = useState(false);

  useEffect(() => {
    const totalSipValue = retirementCalculator(
      currentAge,
      inflationRate,
      retirementage,
      monthlyExpense,
      expectedReturn
    );

    settotalSIP(Math.round(totalSipValue));
  }, []);


  const handleCurrentAge = (event) => {
    const re = /^[0-9.\b]+$/;

    // if value is not blank, then test the regex

    if (event.target.value === "" || re.test(event.target.value)) {
      if (event.target.value > 90 || event.target.value < 1) {
        setcurrentAge(event.target.value);
        setageErr(true);
      } else {
        setcurrentAge(event.target.value);
        setageErr(false);
        const totalSipValue = retirementCalculator(
          event.target.value,
          inflationRate,
          retirementage,
          monthlyExpense,
          expectedReturn
        );

        settotalSIP(Math.round(totalSipValue));
      }
    }
  };

  const handleinflationRate = (event) => {
    const re = /^[0-9.\b]+$/;

    // if value is not blank, then test the regex

    if (event.target.value === "" || re.test(event.target.value)) {
      if (event.target.value > 15 || event.target.value < 1) {
        setinflationRate(event.target.value);
        setinflationErr(true);
      } else {
        setinflationRate(event.target.value);
        setinflationErr(false);
        const totalSipValue = retirementCalculator(
          currentAge,
          event.target.value,
          retirementage,
          monthlyExpense,
          expectedReturn
        );

        settotalSIP(Math.round(totalSipValue));
      }
    }
  };
  const handleretirementage = (event) => {
    const re = /^[0-9.\b]+$/;

    // if value is not blank, then test the regex

    if (event.target.value === "" || re.test(event.target.value)) {
      if (event.target.value > 80 || event.target.value < 25) {
        setretirementage(event.target.value);
        setretAgeErr(true);
      } else {
        setretirementage(event.target.value);
        setretAgeErr(false);
        const totalSipValue = retirementCalculator(
          currentAge,
          inflationRate,
          event.target.value,
          monthlyExpense,
          expectedReturn
        );

        settotalSIP(Math.round(totalSipValue));
      }
    }
  };
  const handleMonthlyExpense = (event) => {
    const totalCurrentMonthlyExpense = parseFloat(
      event.target.value.replace(/,/g, "")
    );

    if (
      totalCurrentMonthlyExpense > 10000000 ||
      totalCurrentMonthlyExpense < 1
    ) {
      setmonthlyExpense(totalCurrentMonthlyExpense);
      setexpenseErr(true);
    } else {
      setmonthlyExpense(totalCurrentMonthlyExpense);
      setexpenseErr(false);
      const totalSipValue = retirementCalculator(
        currentAge,
        inflationRate,
        retirementage,
        totalCurrentMonthlyExpense,
        expectedReturn
      );
      settotalSIP(Math.round(totalSipValue));
    }
  };

  const handleExpRetirePer = (event) => {
    if (event > 12 || event < 1) {
      setexpectedReturn(event);
      setexpectedErr(true);
    } else {
      setexpectedReturn(event);
      setexpectedErr(false);
      const totalSipValue = retirementCalculator(
        currentAge,
        inflationRate,
        retirementage,
        monthlyExpense,
        event
      );

      settotalSIP(Math.round(totalSipValue));
    }
  };

  const handleExpRetirePerAmt = (event) => {
    const re = /^[0-9.\b]+$/;

    // if value is not blank, then test the regex

    if (event.target.value === "" || re.test(event.target.value)) {
      if (event.target.value > 12 || event.target.value < 1) {
        setexpectedReturn(event.target.value);
        setexpectedErr(true);
      } else {
        setexpectedReturn(event.target.value);
        setexpectedErr(false);
        const totalSipValue = retirementCalculator(
          currentAge,
          inflationRate,
          retirementage,
          monthlyExpense,
          event.target.value
        );

        settotalSIP(Math.round(totalSipValue));
      }
    }
  };

  function retirementCalculator(
    currentAge,
    inflationRate,
    retirementage,
    monthlyExpense,
    expectedReturn
  ) {
    let lifeExpentancy = 90;
    let realRateOfReturn =
      (1 + expectedReturn / 100) / (1 + inflationRate / 100) - 1;
    let monthlyEffectiveRate = formulajs.RATE(
      12,
      0,
      -100,
      100 * (1 + realRateOfReturn),
      0
    );
    let yearsToRetirement = retirementage - currentAge;
    let monthlyExpenseAt60 = formulajs.FV(
      inflationRate / 100,
      yearsToRetirement,
      null,
      -monthlyExpense,
      0
    );

    setmonthlyExpenseAge60(Math.round(monthlyExpenseAt60));

    let retirementCorpusRequired = formulajs.PV(
      monthlyEffectiveRate,
      (lifeExpentancy - retirementage) * 12,
      -monthlyExpenseAt60,
      0,
      1
    );

    return retirementCorpusRequired;
  }

  const reqSipAtExpecetedReturnCalculate = (rate) => {
    return formulajs.PMT(
      formulajs.RATE(12, null, -100, 100 * (1 + rate / 100), 0),
      (retirementage - currentAge) * 12,
      null,
      -Math.round(totalSIP),
      1
    );
  };

  const reqLumInvAtExpectedReturnCalculate = (rate) => {
    return formulajs.PV(
      formulajs.RATE(12, null, -100, 100 * (1 + rate / 100), 0),
      (retirementage - currentAge) * 12,
      null,
      -Math.round(totalSIP)
    );
  };

  const handleInvestmentChange = (e)=>{
    settoggleButton(e.target.checked);
  }

  return (
    <section className="inflationtoolsdiv">
    <div className="container">
        <div className="row my-5 gx-5">
        <div className="col-md-6 mb-4">
            <div className="toolsfirstdiv me-md-3">
            <h2 className="mb-3"><span>Retirement</span> Calculator</h2>
            <div className="mb-5">
                <div className="align-items-center row">
                <div className="col-7 text-break">
                    <h4>Enter your Age</h4>
                </div>
                <div className="col-5 d-flex justify-content-end">
                    <input
                    type="text"
                    className="amtwidth"
                    onChange={handleCurrentAge}
                    maxLength={2}
                    value={currentAge}
                    />
                </div>
                <div className="col-8">&nbsp;</div>
                {ageErr ? (
                    <div className="col-12 d-flex justify-content-end errortext">
                    <span style={{ color: "red", fontSize: 12 }}>
                        Value should be between 0 - 90
                    </span>
                    </div>
                ) : null}
                </div>
            </div>

            <div className="mb-4">
                <div className="align-items-center mb-3 row">
                <div className="col-7 text-break">
                    <h4>Enter Inflation Rate</h4>
                </div>
                <div className="col-5 d-flex justify-content-end">
                    <input
                    type="text"
                    className="amtwidth"
                    placeholder="0%"
                    value={inflationRate}
                    onChange={handleinflationRate}
                    maxLength={5}
                    />
                </div>
                <div className="col-8">&nbsp;</div>
                {inflationErr ? (
                    <div className="col-12 d-flex justify-content-end errortext">
                    <span style={{ color: "red", fontSize: 12 }}>
                        Value should be between 1% - 15%
                    </span>
                    </div>
                ) : null}
                </div>
                <div>
                <input
                    type="range"
                    className="w-100"
                    min="1"
                    max="15"
                    step="0.1"
                    value={inflationRate}
                    onChange={handleinflationRate}
                />
                <div className="d-flex justify-content-between startendval">
                    <span>1 %</span>
                    <span>15 %</span>
                </div>
                </div>
            </div>
            <div className="mb-4">
                <div className="align-items-center mb-3 row">
                <div className="col-7 text-break">
                    <h4>Enter your Retirement Age</h4>
                </div>
                <div className="col-5 d-flex justify-content-end">
                    <input
                    type="text"
                    className="amtwidth"
                    placeholder="Enter Years"
                    value={retirementage}
                    onChange={handleretirementage}
                    maxLength={2}
                    />
                </div>
                <div className="col-8">&nbsp;</div>
                {retAgeErr ? (
                    <div className="col-12 d-flex justify-content-end errortext">
                    <span style={{ color: "red", fontSize: 12 }}>
                        Value should be between 40 - 80
                    </span>
                    </div>
                ) : null}
                </div>
                <div>
                <input
                    type="range"
                    className="w-100"
                    min="25"
                    max="80"
                    value={retirementage}
                    onChange={handleretirementage}
                />
                <div className="d-flex justify-content-between startendval">
                    <span>25 Years</span>
                    <span>80 Years</span>
                </div>
                </div>
            </div>

            <div className="mb-5">
                <div className="align-items-center row">
                <div className="col-7 text-break">
                    <h4>Current Monthly Expense</h4>
                </div>
                <div className="col-5 d-flex justify-content-end">
                    <NumericFormat
                    type="text"
                    className="amtwidth"
                    onChange={handleMonthlyExpense}
                    y
                    value={monthlyExpense}
                    placeholder="₹ 0"
                    thousandSeparator={","}
                    thousandsGroupStyle="lakh"
                    decimalSeparator={"."}
                    />
                </div>
                <div className="col-8">&nbsp;</div>
                {expenseErr ? (
                    <div className="col-12 d-flex justify-content-end errortext">
                    <span style={{ color: "red", fontSize: 12 }}>
                        Value should be between 1 - 1,00,00,000
                    </span>
                    </div>
                ) : null}
                </div>
            </div>
            <div className="mb-3">
                <div className="align-items-center row">
                <div className="col-12 text-break">
                    <h4>Choose expected return post retirement</h4>
                </div>
                {/* <div className="col-5 d-flex justify-content-end">
                    <input
                    type="text"
                    className="amtwidth"
                    onChange={handleExpRetirePerAmt}
                    value={expectedReturn}
                    maxLength={2}
                    />
                </div>
                <div className="col-8">&nbsp;</div>
                {expectedErr ? (
                    <div className="col-12 d-flex justify-content-end">
                    <span style={{ color: "red", fontSize: 12 }}>
                        Value should be between 1 - 15
                    </span>
                    </div>
                ) : null} */}
                </div>
            </div>
            <div className="mb-5">
                <div className="row">
                <div className="col-md-12">
                    <div className="retirement">
                    <div
                        className={
                        expectedReturn === 5
                            ? "btn btn-primary me-3 mb-3"
                            : "btn btn-outline-primary me-3 mb-3"
                        }
                        onClick={() => handleExpRetirePer(5)}
                    >
                        5 %
                    </div>
                    <div
                        className={
                        expectedReturn === 8
                            ? "btn btn-primary me-3 mb-3"
                            : "btn btn-outline-primary me-3 mb-3"
                        }
                        onClick={() => handleExpRetirePer(8)}
                    >
                        8 %
                    </div>
                    <div
                        className={
                        expectedReturn === 10
                            ? "btn btn-primary me-3 mb-3"
                            : "btn btn-outline-primary me-3 mb-3"
                        }
                        onClick={() => handleExpRetirePer(10)}
                    >
                        10 %
                    </div>
                    <div
                        className={
                        expectedReturn === 12
                            ? "btn btn-primary me-3 mb-3"
                            : "btn btn-outline-primary me-3 mb-3"
                        }
                        onClick={() => handleExpRetirePer(12)}
                    >
                        12 %
                    </div>
                    {/* <div
                        className={
                        expectedReturn === 15
                            ? "btn btn-primary me-3 mb-3"
                            : "btn btn-outline-primary me-3 mb-3"
                        }
                        onClick={() => handleExpRetirePer(15)}
                    >
                        15 %
                    </div> */}
                    </div>
                </div>
                </div>
            </div>
            </div>
            {monthlyExpense > 0 &&
            ageErr === false &&
            inflationErr === false &&
            retAgeErr === false &&
            expenseErr === false &&
            expectedErr === false ? (
            <div>
                <div className="currentandfuture">
                <div className="row">
                    <div className="col-6">
                    <p className="text">Years to Retirement</p>
                    <p className="cfamount my-2">
                        {retirementage - currentAge}
                    </p>
                    </div>
                    <div className="col-6">
                    <p className="text">Monthly Expense at the Age of 60</p>
                    <p className="cfamount my-2">
                        ₹ {digitToRupeeNotation(monthlyExpenseAge60)}
                    </p>
                    </div>
                    <div className="col-12">
                    <div className="textbluediv">
                        <h4 className="text-center">Retirement Corpus Required <span className="fw-bold">₹ {digitToRupeeNotation(totalSIP)}</span></h4>
                    </div>
                    </div>
                </div>
                </div>
            </div>
            ) : (
            ""
            )}
        </div>
        <div className="col-md-6 mb-4">
            <div className="textgreendiv">
                <div className="row">
                    <div className="col-12">
                    <div className="d-flex justify-content-between">
                        <p className="title">Required Investment</p>
                        <div className="form-check form-switch d-flex align-items-center p-0">
                        <label className="form-check-label">Lumpsum</label>
                        <input
                            className="form-check-input colorSwitch"
                            type="checkbox"
                            role="switch"
                            id="flexSwitchCheckDefault1"
                            // defaultChecked="checked"
                            onClick={(e) => handleInvestmentChange(e)}
                            checked={toggleButton}
                        />
                        <label
                            className="form-check-label"
                            htmlFor="flexSwitchCheckDefault1"
                        >
                            Monthly SIP
                        </label>
                        </div>
                    </div>
                    <div className="line"></div>
                    </div>
                    <div className="col-md-4 mb-2">
                    {toggleButton == false ? 
                    <div className="whitebg">
                        <p className="text">Expected return rate of <span className="fw-bold">6 %</span></p>
                        <p className="cfamount my-2">
                        {isNaN(reqLumInvAtExpectedReturnCalculate(6))
                            ? "0"
                            : digitToRupeeNotation(
                            Math.round(
                                reqLumInvAtExpectedReturnCalculate(6)
                            )
                            )}
                        </p>
                    </div>
                    :
                    <div className="whitebg">
                        <p className="text">Expected return rate of <span className="fw-bold">6 %</span></p>
                        <p className="cfamount my-2">
                        {isNaN(reqSipAtExpecetedReturnCalculate(6))
                            ? "0"
                            : digitToRupeeNotation(
                            Math.round(
                                reqSipAtExpecetedReturnCalculate(6)
                            )
                            )}
                        </p>
                    </div> }
                    </div>
                    <div className="col-md-4 mb-2">
                    {toggleButton == false ? 
                    <div className="whitebg">
                        <p className="text">Expected return rate of <span className="fw-bold">9 %</span></p>
                        <p className="cfamount my-2">
                        {isNaN(reqLumInvAtExpectedReturnCalculate(9))
                            ? "0"
                            : digitToRupeeNotation(
                            Math.round(
                                reqLumInvAtExpectedReturnCalculate(9)
                            )
                            )}
                        </p>
                    </div>
                    :
                    <div className="whitebg">
                        <p className="text">Expected return rate of <span className="fw-bold">9 %</span></p>
                        <p className="cfamount my-2">
                        {isNaN(reqSipAtExpecetedReturnCalculate(9))
                            ? "0"
                            : digitToRupeeNotation(
                            Math.round(
                                reqSipAtExpecetedReturnCalculate(9)
                            )
                            )}
                        </p>
                    </div>}
                    </div>
                    <div className="col-md-4 mb-2">
                    {toggleButton == false ? 
                    <div className="whitebg">
                        <p className="text">Expected return rate of <span className="fw-bold">12 %</span></p>
                        <p className="cfamount my-2">
                        {isNaN(reqLumInvAtExpectedReturnCalculate(12))
                            ? "0"
                            : digitToRupeeNotation(
                            Math.round(
                                reqLumInvAtExpectedReturnCalculate(12)
                            )
                            )}
                        </p>
                    </div>
                    :
                    <div className="whitebg">
                        <p className="text">Expected return rate of <span className="fw-bold">12 %</span></p>
                        <p className="cfamount my-2">
                        {isNaN(reqSipAtExpecetedReturnCalculate(12))
                            ? "0"
                            : digitToRupeeNotation(
                            Math.round(
                                reqSipAtExpecetedReturnCalculate(12)
                            )
                            )}
                        </p>
                    </div>}
                    </div>
                </div>
            </div>
        </div>
        </div>
    </div>
    </section>
  );
};


export default RetirementCalculator;
